export enum TipoAcaoAssinaturaEnum
{
    Nenhuma = 1,
    AssinandoICPBrasil = 2,
    AssinandoGOVBR = 3,
    Rejeitando = 4
}
